const Colors = {
  black1: '#000',
  gray1: '#787878',
  gray2: '#b1b1b1',
  gray3: '#e0e0e0',
  gray4: '#f5f5f5',
  gray10: '#8c8c8c',
  white1: '#fff',
  orange1: '#ff6e3c',
  orange2: '#fffaf5',
  orange3: '#dc5a28'
};

export default Colors;



// WEBPACK FOOTER //
// ./src/constants/colors.js